<template>
  <van-popup
    v-model="kaiguan"
    get-container="body"
    :style="{background:'transparent'}"
    @click-overlay="closeLogin"
    @opened="handleGetFocus"
  >
    <div class="login">
      <p class="title mt">登录雷电账号</p>
      <div class="mt border-color">
        <input type="text" class="Input" placeholder="账号" v-model="account" ref="content" />
      </div>
      <div class="mt border-color">
        <input type="password" class="Input" placeholder="密码" v-model="password" />
      </div>
      <van-button
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="handleLogin"
      >登录</van-button>
      <p class="regist">
        没有账号，
        <a href="https://sso.ldmnq.com/regist" target="_blank" class="reg">立即注册</a>
      </p>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "Login",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    account: "",
    password: "",
    autofocus: true
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    }
  },
  methods: {
    //关闭弹窗
    closeLogin() {
      this.$emit("cancle-login");
    },
    //登陆
    async handleLogin() {
      if (!this.account || !this.password) {
        this.$toast({
          message: "请填写完整信息",
          duration: 1200,
          position: "middle",
          type: "fail"
        });
        return;
      }
      let encry = this.$jsencrypt;
      encry.setPublicKey(
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6uOzpfsQ1ScFPt6QPBNYFLIxm/yJC4/7UtLcbZAYeB2Wz85mzaNnaQuKb4nkGC1ltcRKukztWRRKA+gVBOt5cCAwEAAQ=="
      );
      let userMessage = {
        account: encry.encrypt(this.account),
        password: encry.encrypt(this.password)
      };
      let { data: loginDes } = await this.$api.activity.login(userMessage);
      if (loginDes.code === 0) {
        this.$toast({
          type: "success",
          message: "登录成功",
          duration: 1200,
          position: "middle"
        });
        this.$emit("cancle-login");
        this.$emit("get-msg", loginDes.data);
      } else {
        this.$toast({
          type: "fail",
          message: "账号或密码\n不正确",
          duration: 1200,
          position: "middle"
        });
      }
    },
    //获得焦点
    handleGetFocus() {
      this.$refs.content.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 745px;
  padding: 50px;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  border-radius: 30px;
  text-align: center;
  font-size: 0.45rem;
  .mt {
    margin-bottom: 40px;
  }
  .border-color {
    border: 1px solid #c6c6c6;
    border-radius: 10px;
  }
  .Input {
    width: 100%;
    height: 100px;
    font-size: 30px;
    padding-left: 35px;
  }
  .btn {
    cursor: pointer;
    height: 100px;
    line-height: 100px;
    font-size: 35px;
    border-radius: 50px;
  }
  .regist {
    margin-top: 20px;
    font-size: 30px;
    a {
      color: #f84848;
    }
    .reg {
      text-decoration: underline;
    }
  }
}
</style>